import { Box, styled } from '@mui/material';

export const SkeletonWrapper = styled(Box)(({ theme }) => ({
	width: '100%',
	borderBottom: theme.palette.solutions?.[100],
	display: 'flex',
	justifyContent: 'center',
}));

interface TabSkeletonItemProps {
	isActive?: boolean;
	indicatorColor?: string;
}

export const TabSkeletonItem = styled(Box, {
	shouldForwardProp: (prop) => prop !== 'isActive' && prop !== 'indicatorColor',
})<TabSkeletonItemProps>(({ isActive, indicatorColor }) => ({
	flex: 1,
	display: 'flex',
	justifyContent: 'center',
	padding: '4px 16px 14px 16px',
	cursor: 'pointer',
	borderBottom: isActive
		? `1px solid ${indicatorColor}`
		: '1px solid transparent',
}));

export const TabContent = styled(Box)({
	display: 'flex',
	alignItems: 'center',
	gap: 8,
});
